import axios from 'axios';

const DOCX_CONTENT_TYPE =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
const ZIP_CONTENT_TYPE = 'application/zip';

const filenameFromHeader = (header, fallback) => {
  const match = String(header || '').match(/filename="?([^";]+)"?/i);
  return match?.[1] || fallback;
};

const downloadFile = async (request, fallbackFilename, contentType) => {
  const response =
    typeof request === 'string'
      ? await axios.get(request, { responseType: 'blob' })
      : await axios.post(request.url, request.data, { responseType: 'blob' });
  const { data, headers } = response;
  const blob = data instanceof Blob ? data : new Blob([data], { type: contentType });
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = downloadUrl;
  link.download = filenameFromHeader(headers?.['content-disposition'], fallbackFilename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
};

const downloadDocx = (request, fallbackFilename) =>
  downloadFile(request, fallbackFilename, DOCX_CONTENT_TYPE);

const downloadZip = (request, fallbackFilename) =>
  downloadFile(request, fallbackFilename, ZIP_CONTENT_TYPE);

export const downloadOrderReceipt = (order) =>
  downloadDocx(`/orders/${order.id}/receipt`, `receipt_${order.uuidOrder || order.id}.docx`);

export const downloadSelectedOrderReceipts = (orders) =>
  downloadZip(
    { url: '/orders/receipts', data: { orderIds: orders.map((order) => order.id) } },
    'selected-order-receipts.zip'
  );

export const downloadPendingOrderReceipts = () =>
  downloadZip('/orders/receipts/pending', 'pending-order-receipts.zip');

export const downloadPendingProductionNotes = () =>
  downloadDocx('/orders/production-notes/pending', 'factory-notes-pending.docx');

export const downloadProductionNotes = (order) =>
  downloadDocx(
    `/orders/${order.id}/production-notes`,
    `production-notes_${order.uuidOrder || order.id}.docx`
  );

export const downloadSelectedProductionNotes = (orders) =>
  downloadDocx(
    { url: '/orders/production-notes', data: { orderIds: orders.map((order) => order.id) } },
    'selected-production-notes.docx'
  );
